import { CSSProperties, StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../styles/colors';
import { baseStyles } from '../../styles/styles';

// tslint:disable:object-literal-key-quotes

const compactLinksHeight = 34;
const normalHeaderHeight = 100;
const compactHeaderHeight = 120;
const compactWidthMax = 999;
const compactWidth = `@media only screen and (max-width: ${ compactWidthMax }px)`;

export const styleSheet = StyleSheet.create({
	bottomLinks: {
		background: '#fff',
		borderBottom: '1px solid #d9d9d9',
		boxSizing: 'border-box',
		display: 'none',
		height: compactLinksHeight,
		padding: '6px 10px',
		[compactWidth]: {
			display: 'block',
		},
	},
	container: {
		height: normalHeaderHeight,
		[compactWidth]: {
			height: compactHeaderHeight,
		},
	},
	fixedContent: {
		height: normalHeaderHeight,
		left: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 8,
		[compactWidth]: {
			height: compactHeaderHeight,
		},
	},
	link: {
		color: '#646464',
		fontSize: 16,
		textDecoration: 'none',
		// tslint:disable-next-line:object-literal-sort-keys
		':not(:first-child)': {
			marginLeft: 38,
		},
		':hover': {
			color: brandPrimary,
		},
		[compactWidth]: {
			fontSize: 14,
			// tslint:disable-next-line:object-literal-sort-keys
			':not(:first-child)': {
				marginLeft: 0,
			},
		},
	},
	links: {
		alignItems: 'center',
		display: 'flex',
		[compactWidth]: {
			justifyContent: 'space-between',
			maxWidth: 400,
		},
	},
	logoLink: {
	},
	logoLinkIcon: {
		[compactWidth]: {
			width: 144,
		},
	},
	mainContent: {
		alignItems: 'flex-start',
		background: '#fff',
		borderBottom: '1px solid #d9d9d9',
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		height: '100%',
		justifyContent: 'space-between',
		padding: '30px 30px 0 30px',
		width: '100%',
		[compactWidth]: {
			borderBottom: '1px solid #cae0ec',
			height: `calc(100% - ${ compactLinksHeight }px)`,
			padding: '18px 15px 10px 15px',
		},
	},
	normalLinks: {
		marginTop: 5,
		[compactWidth]: {
			display: 'none',
		},
	},
	rightAccessory: {
		alignItems: 'center',
		display: 'flex',
		[compactWidth]: {
			flexDirection: 'column',
		},
	},
	signInLink: {
		fontSize: 16,
		marginRight: 38,
		textDecoration: 'none',
		[compactWidth]: {
			alignSelf: 'center',
			fontSize: 12,
			margin: '8px auto auto',
			order: 2,
			textDecoration: 'underline',
		},
		// tslint:disable-next-line: object-literal-sort-keys
		':hover': {
			color: brandPrimary,
		},
	},
	spacer: {
		height: normalHeaderHeight,
		[compactWidth]: {
			height: compactHeaderHeight,
		},
	},
	tryButton: {
		display: 'inline-flex',
		textDecoration: 'none',
		...baseStyles.ctaButton as CSSProperties,
		[compactWidth]: {
			...baseStyles.ctaButtonSmall as CSSProperties,
			order: 1,
		},
	},
});
